import { useState } from "react";
import { CalendarHeart, ImageIcon, Loader2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatErr as errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShareImageDialog } from "@/components/BadgeShare";
import { renderMonthImage, shortLine } from "@/lib/monthImage";

export function MonthReview() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [img, setImg] = useState(false);
  const load = async () => {
    setBusy(true);
    try { setD((await api.get("/ai/month-review")).data); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const link = `${window.location.origin}/registrieren?ref=${user?.referral_code || ""}`;
  const share = async () => {
    const text = `${d.text}\n\nMach mit in der itzPlay Community: ${window.location.origin}`;
    if (navigator.share) navigator.share({ text }).catch(() => {});
    else { await navigator.clipboard.writeText(text); toast.success("Text kopiert – jetzt einfügen und teilen!"); }
  };
  return (
    <section className="shine glow-pulse rounded-3xl bg-gradient-to-br from-rose-50 via-white to-amber-50 border border-rose-100 p-5 space-y-3" style={{ "--shine-delay": "2.5s" }} data-testid="month-review">
      <div className="flex items-center gap-3">
        <span className="w-11 h-11 rounded-2xl pink-gradient text-white flex items-center justify-center"><CalendarHeart className="w-6 h-6" /></span>
        <div className="flex-1"><h2 className="font-display text-lg font-extrabold">Mein Monatsrückblick</h2><p className="text-xs text-slate-500">Dein Monat in der Community – persönlich zusammengefasst</p></div>
      </div>
      {d ? (
        <>
          <p className="text-sm leading-relaxed whitespace-pre-wrap" data-testid="month-review-text">{d.text}</p>
          <div className="flex flex-wrap gap-2">
            <button onClick={() => setImg(true)} data-testid="month-review-image" className="h-10 px-4 rounded-full bg-rose-600 hover:bg-rose-700 text-white text-sm font-bold flex items-center gap-2 transition-colors"><ImageIcon className="w-4 h-4" /> Als Story-Bild teilen</button>
            <button onClick={share} data-testid="month-review-share" className="h-10 px-4 rounded-full bg-white border border-rose-200 text-rose-600 hover:bg-rose-50 text-sm font-bold flex items-center gap-2 transition-colors"><Share2 className="w-4 h-4" /> Text teilen</button>
          </div>
          {img && <ShareImageDialog prefix="month-review" title="Monatsrückblick teilen" alt="Monatsrückblick" fileBase={`itzcouple-rueckblick-${d.month}`} onClose={() => setImg(false)}
            description="Teil deinen Monat als Story auf Instagram oder TikTok – dein Einladungslink ist mit drauf."
            msg={`Mein Monat in der itzPlay Community: ${shortLine(d.text)} Mach mit: ${link}`}
            render={(format) => renderMonthImage({ review: d, user, link, format })} deps={[d.month, d.day, user?.user_id]} />}
        </>
      ) : (
        <button onClick={load} disabled={busy} data-testid="month-review-btn" className="h-11 px-5 rounded-full bg-rose-600 hover:bg-rose-700 text-white text-sm font-bold flex items-center gap-2 disabled:opacity-60 transition-colors">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <CalendarHeart className="w-4 h-4" />} {busy ? "Wird geschrieben …" : "Rückblick anzeigen"}
        </button>
      )}
    </section>
  );
}
